import { Button } from '@storeblocks/button';
import { type FC } from 'react';
import styled from 'styled-components';

import { Column, Row } from '@/components/Grid';
import { SurfaceWidget } from '@/components/Widget';
import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

export const FundsSustainabilityBannerWidget: FC = () => {
  const texts = useTexts();
  const getTrackId = useGetTrackId();

  return (
    <SurfaceWidget>
      <Row>
        <Column $span={8}>
          <Content>
            <StyledH2>{texts.news.assets.sustainability.title}</StyledH2>

            <Button
              as="a"
              variant="subtle"
              href={texts.news.assets.sustainability.link}
              rel="noreferrer"
              target="_blank"
              data-trackid={getTrackId(
                'go-to-news-assets-sustainability',
                TrackingElement.Link,
              )}
            >
              {texts.news.assets.sustainability.buttonLabel}
            </Button>
          </Content>
        </Column>

        <Column $span={4}>
          <StyledIcon>
            <img
              alt="Sustainable illustration"
              title="Sustainable illustration"
              src={`${window.config.storeblocksAssetsBaseUrl}/icons/sustainability.svg`}
            />
          </StyledIcon>
        </Column>
      </Row>
    </SurfaceWidget>
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 40px;
`;

const StyledIcon = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  > img {
    width: 115px;
    height: 115px;
  }
`;

const StyledH2 = styled.h2`
  font-size: 24px;
`;
